module.exports = __webpack_public_path__ + "img/haukkala_sisalta.aff07e96.jpeg";